// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../imgs/neighborhood.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../imgs/blobs-hero.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jWrqTRRQoo3ZGlMarMGW {
  order: -1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: var(--white-color);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-position-x: center, center;
  background-position-y: bottom, bottom;
  background-size:
    auto 36vh,
    auto 60vh;
  background-repeat: no-repeat;
  min-height: calc(100vh - var(--global-nav-height));
  padding-bottom: 1rem;
}

.vM0bBehxk5nr_BdqZxLm {
  min-height: calc(90vh - var(--global-nav-height));
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: var(--space-l) var(--space-3xs-2xl) var(--space-xl);
}

.AkLO4rz4UeQWFLlrX8Ep {
  max-width: var(--grid-max-width);
  padding-inline: var(--grid-gutter);
  margin-inline: auto;
}

.BTAEjTEN8EQwjMQjmT9_ {
  padding-bottom: var(--space-3xl);
}

.iBBiNbutXqWiOGWDHO3R {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.iBBiNbutXqWiOGWDHO3R .Qea4b1MNJOkdqAbF7lIu {
  display: block;
  width: auto;
  max-width: 100%;
  max-height: var(--space-5xl);
  object-fit: fill;
  object-position: left center;
}

.iBBiNbutXqWiOGWDHO3R h1 {
  font-size: var(--step-3);
  line-height: 1.5;
  color: var(--md-grey-color);
  margin-top: var(--space-s-m);
  margin-bottom: 0;
  width: 80%;
  transition: var(--global-nav-transition);
}

p.m7hMskEZyYmT5s_Lq2tD {
  font-size: var(--step-1);
  color: var(--text-lighter-color);
}

.m7hMskEZyYmT5s_Lq2tD {
  max-width: 64rem;
  text-wrap: balance;
  line-height: 1.75;
  margin-top: 2rem;
}

.FVdwiNJumw4DjKHO1F4D {
  width: 100%;
  display: flex;
  justify-content: center;
}

.iW9xIbihlpa4ojS2oB4Y {
  font-size: var(--step-5);
  color: rgba(255, 255, 255, 0.9);
  text-shadow: 0 0.125em 0.25em rgba(0, 0, 0, 0.6);
  text-align: center;
  background: none;
  background-color: transparent;
  border: none;
  text-decoration: none;
  transition: var(--global-nav-transition);
  cursor: pointer;
  z-index: 200;
}

.iW9xIbihlpa4ojS2oB4Y:hover,
.iW9xIbihlpa4ojS2oB4Y:focus {
  color: rgba(255, 255, 255, 1);
  text-shadow: 0 0.125em 0.25em rgba(0, 0, 0, 0.4);
}

.iW9xIbihlpa4ojS2oB4Y:active {
  color: rgba(255, 255, 255, 0.8);
  text-shadow: 0 0 0.25em rgba(0, 0, 0, 0.3);
}

.jfJa4YughQGQZrYVtaSr {
  display: flex;
  flex-direction: column;
  width: min-content;
  padding-left: 2rem;
}

.sI2mQWjW6z0MhTtWFYdD {
  margin: auto;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
  gap: var(--space-s-m);
}

.sI2mQWjW6z0MhTtWFYdD > * {
  margin: 0;
  white-space: normal;
}
`, "",{"version":3,"sources":["webpack://./src/pages/HomePage/components/Hero.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,oCAAoC;EACpC;2CACqC;EACrC,qCAAqC;EACrC,qCAAqC;EACrC;;aAEW;EACX,4BAA4B;EAC5B,kDAAkD;EAClD,oBAAoB;AACtB;;AAEA;EACE,iDAAiD;EACjD,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,4DAA4D;AAC9D;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,2BAA2B;EAC3B,4BAA4B;EAC5B,gBAAgB;EAChB,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,YAAY;EACZ,qBAAqB;EACrB,wCAAwC;EACxC,eAAe;EACf,YAAY;AACd;;AAEA;;EAEE,6BAA6B;EAC7B,gDAAgD;AAClD;;AAEA;EACE,+BAA+B;EAC/B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB","sourcesContent":[".heroHome {\n  order: -1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  background-color: var(--white-color);\n  background-image: url(\"../../../imgs/neighborhood.svg\"),\n    url(\"../../../imgs/blobs-hero.png\");\n  background-position-x: center, center;\n  background-position-y: bottom, bottom;\n  background-size:\n    auto 36vh,\n    auto 60vh;\n  background-repeat: no-repeat;\n  min-height: calc(100vh - var(--global-nav-height));\n  padding-bottom: 1rem;\n}\n\n.hero {\n  min-height: calc(90vh - var(--global-nav-height));\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  padding: var(--space-l) var(--space-3xs-2xl) var(--space-xl);\n}\n\n.uContainer {\n  max-width: var(--grid-max-width);\n  padding-inline: var(--grid-gutter);\n  margin-inline: auto;\n}\n\n.heroContent {\n  padding-bottom: var(--space-3xl);\n}\n\n.logoTag {\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n}\n\n.logoTag .homeLogo {\n  display: block;\n  width: auto;\n  max-width: 100%;\n  max-height: var(--space-5xl);\n  object-fit: fill;\n  object-position: left center;\n}\n\n.logoTag h1 {\n  font-size: var(--step-3);\n  line-height: 1.5;\n  color: var(--md-grey-color);\n  margin-top: var(--space-s-m);\n  margin-bottom: 0;\n  width: 80%;\n  transition: var(--global-nav-transition);\n}\n\np.lead {\n  font-size: var(--step-1);\n  color: var(--text-lighter-color);\n}\n\n.lead {\n  max-width: 64rem;\n  text-wrap: balance;\n  line-height: 1.75;\n  margin-top: 2rem;\n}\n\n.leadWrapper {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n\n.pageDownBtn {\n  font-size: var(--step-5);\n  color: rgba(255, 255, 255, 0.9);\n  text-shadow: 0 0.125em 0.25em rgba(0, 0, 0, 0.6);\n  text-align: center;\n  background: none;\n  background-color: transparent;\n  border: none;\n  text-decoration: none;\n  transition: var(--global-nav-transition);\n  cursor: pointer;\n  z-index: 200;\n}\n\n.pageDownBtn:hover,\n.pageDownBtn:focus {\n  color: rgba(255, 255, 255, 1);\n  text-shadow: 0 0.125em 0.25em rgba(0, 0, 0, 0.4);\n}\n\n.pageDownBtn:active {\n  color: rgba(255, 255, 255, 0.8);\n  text-shadow: 0 0 0.25em rgba(0, 0, 0, 0.3);\n}\n\n.pageDownBtnWrapper {\n  display: flex;\n  flex-direction: column;\n  width: min-content;\n  padding-left: 2rem;\n}\n\n.btnGroup {\n  margin: auto;\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-content: center;\n  gap: var(--space-s-m);\n}\n\n.btnGroup > * {\n  margin: 0;\n  white-space: normal;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"heroHome": `jWrqTRRQoo3ZGlMarMGW`,
	"hero": `vM0bBehxk5nr_BdqZxLm`,
	"uContainer": `AkLO4rz4UeQWFLlrX8Ep`,
	"heroContent": `BTAEjTEN8EQwjMQjmT9_`,
	"logoTag": `iBBiNbutXqWiOGWDHO3R`,
	"homeLogo": `Qea4b1MNJOkdqAbF7lIu`,
	"lead": `m7hMskEZyYmT5s_Lq2tD`,
	"leadWrapper": `FVdwiNJumw4DjKHO1F4D`,
	"pageDownBtn": `iW9xIbihlpa4ojS2oB4Y`,
	"pageDownBtnWrapper": `jfJa4YughQGQZrYVtaSr`,
	"btnGroup": `sI2mQWjW6z0MhTtWFYdD`
};
export default ___CSS_LOADER_EXPORT___;
